import { Grid, styled } from "@mui/material";

const CenteredColumnGrid = styled(Grid)({
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

export default CenteredColumnGrid;
